import "./*.scss";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import Swiper, { Pagination } from "swiper";
import { media } from "../../assets/js/utilities/media.js";

function setup({ el }) {
  const context = el;
  const selectors = {
		ctaGrid: "[data-swiper-cta-grid]",
	};
  const elements = {
    ctaGrid: context.querySelector(selectors.ctaGrid),
  }
  let swiper;

  Swiper.use([Pagination]);

	const match = () => {
		swiper = new Swiper(elements.ctaGrid, {
			spaceBetween: 25,
			loop: true,
			slidesPerView: 1.25,
			centeredSlides: true,
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: true,
			},
			breakpoints: {
				[media.sizes.xs]: {
					slidesPerView: 2,
				},
			},
		});
	};

	const unmatch = () => {
		if (!elements.ctaGrid.swiper) return;

		swiper.destroy(true, true);
	};

	media.is("sm", "max", match, unmatch);
}

function init() {

  document.querySelectorAll("[data-module='cta-grid']").forEach((el) => {
		setup({ el });
	});

}

export default init;
